import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
    baseURL: "/correctionV1_api", // url = base url + request url
    timeout: 300000,
});
export default service;
